import { clinicApi } from "@/domains/multi/clinicApi";
import type { PlanChangeSecretaryCandidates } from "@/domains/subscription/planChangeSecretaryCandidates";
import { useQuery } from "@tanstack/react-query";
import { clinicSecretaryPlanChangeQueryKey } from "@/components/subscription/subscriptionCheckoutPlanFlow";

export function useSoloSecretaryMigration(
    userId: string | undefined,
    enabled: boolean,
    _useClinicBilling = true,
) {
    return useQuery({
        queryKey: clinicSecretaryPlanChangeQueryKey(userId),
        queryFn: async (): Promise<PlanChangeSecretaryCandidates> => {
            const { data } = await clinicApi.fetchChangePlanSecretaryCandidates();
            return data;
        },
        enabled: enabled && Boolean(userId),
        staleTime: 30_000,
    });
}

export function countSoloSecretaryLinks(summary: PlanChangeSecretaryCandidates | undefined): number {
    if (!summary) {
        return 0;
    }

    return summary.items.length + summary.pendingInvites.length;
}

export function hasSoloSecretaryLinks(summary: PlanChangeSecretaryCandidates | undefined): boolean {
    return countSoloSecretaryLinks(summary) > 0;
}
